export default "__VITE_ASSET__e4442360__"